var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.5 5.334a4.5 4.5 0 0 1 9 0v2.127c0 .414.176.808.484 1.085l.739.665c1.162 1.046.791 2.953-.678 3.487l-.141.052c-.59.214-1.19.389-1.798.523-.542 1.171-1.87 1.894-3.106 1.894-1.235 0-2.563-.723-3.105-1.894a14.37 14.37 0 0 1-1.798-.523l-.14-.052c-1.47-.534-1.84-2.44-.679-3.487l.739-.665A1.46 1.46 0 0 0 3.5 7.461V5.334Zm2.804 8.179A2.623 2.623 0 0 0 8 14.167c.614 0 1.244-.252 1.697-.654a14.356 14.356 0 0 1-3.393 0ZM8 1.834a3.5 3.5 0 0 0-3.5 3.5v2.127a2.46 2.46 0 0 1-.814 1.829l-.739.665a1.072 1.072 0 0 0 .351 1.804l.14.05a13.348 13.348 0 0 0 9.124 0l.14-.05c.761-.277.953-1.263.352-1.804l-.739-.665a2.46 2.46 0 0 1-.814-1.83V5.335a3.5 3.5 0 0 0-3.5-3.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.90f26e5afb715cc0c9f7872c8cab659f.svg";
export { ForwardRef as ReactComponent };